import React, { HTMLAttributes } from 'react'
import { Box } from '@deal/components'
import CloseIcon from './close.svg'
import classnames from 'classnames'
import { Button } from '@deal/components'
import { PageKeySetter, PageKeyPriority } from '@deal/page-key'
// @ts-ignore TODO: Write typings for react-scrolllock
import ScrollLock from 'react-scrolllock'
import styles from './styles.css'

interface FlyoutMenuSectionHeaderProps extends HTMLAttributes<HTMLDivElement> {}

const FlyoutMenuSectionHeader: React.SFC<FlyoutMenuSectionHeaderProps> = ({
  children,
  className,
  ...rest
}) => {
  return (
    <div className={classnames(styles.header, className)} {...rest}>
      {children}
    </div>
  )
}

export interface FlyoutMenuProps extends Omit<HTMLAttributes<HTMLDivElement>, 'className'> {
  open: boolean
  from?: 'left' | 'right'
  title?: string
  pageKey?: string
  onClose?: React.MouseEventHandler
  overlayClassName?: string
  menuClassName?: string
}

const FlyoutMenu: React.SFC<FlyoutMenuProps> = ({
  open,
  from = 'left',
  title,
  pageKey,
  onClose,
  overlayClassName,
  menuClassName,
  children,
  ...rest
}) => {
  return (
    <div
      className={classnames(styles.overlay, overlayClassName, {
        [styles.closed]: !open
      })}
      onClick={onClose}
      {...rest}
    >
      {pageKey && open ? (
        <PageKeySetter value={pageKey} priority={PageKeyPriority.OVERLAY} />
      ) : null}
      <ScrollLock isActive={open}>
        <Box
          column
          spacing="none"
          className={classnames(styles.menu, menuClassName, [styles[from]])}
          props={{
            onClick: e => e.stopPropagation()
          }}
        >
          {title && (
            <FlyoutMenuSectionHeader>
              {title}
              <Button
                variant="secondary-link"
                className={styles.closeButton}
                size="large"
                onClick={onClose}
              >
                <CloseIcon className={styles.removeIcon} fill="#c3c7ca" />
              </Button>
            </FlyoutMenuSectionHeader>
          )}

          {children}
        </Box>
      </ScrollLock>
    </div>
  )
}

export default FlyoutMenu
export { FlyoutMenuSectionHeader }
